export default {
  pdfTemplates: []
}
